import type { Tab } from '../lib/store'
import './TabBar.css'

const TABS: { key: Tab; label: string; path: React.ReactNode }[] = [
  {
    key: 'list',
    label: 'List',
    path: (
      <>
        <path d="M9 6h11M9 12h11M9 18h11" />
        <circle cx="4.5" cy="6" r="1.5" />
        <circle cx="4.5" cy="12" r="1.5" />
        <circle cx="4.5" cy="18" r="1.5" />
      </>
    ),
  },
  {
    key: 'map',
    label: 'Map',
    path: (
      <>
        <path d="M9 4 3 6.5v13L9 17l6 3 6-2.5v-13L15 7Z" />
        <path d="M9 4v13M15 7v13" />
      </>
    ),
  },
  {
    key: 'household',
    label: 'Household',
    path: (
      <>
        <circle cx="9" cy="8" r="3" />
        <path d="M3.5 19a5.5 5.5 0 0 1 11 0" />
        <path d="M16 6.2a3 3 0 0 1 0 5.6M17.5 19a5.5 5.5 0 0 0-2-4.2" />
      </>
    ),
  },
  {
    key: 'profile',
    label: 'Profile',
    path: (
      <>
        <circle cx="12" cy="8" r="3.4" />
        <path d="M5 20a7 7 0 0 1 14 0" />
      </>
    ),
  },
]

export function TabBar({
  active,
  onChange,
}: {
  active: Tab
  onChange: (tab: Tab) => void
}) {
  return (
    <nav className="tabbar" aria-label="Main">
      {TABS.map((t) => {
        const on = t.key === active
        return (
          <button
            key={t.key}
            className={`tabbar__tab${on ? ' is-active' : ''}`}
            aria-current={on ? 'page' : undefined}
            onClick={() => onChange(t.key)}
          >
            <svg
              width="23"
              height="23"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={on ? 2.1 : 1.7}
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              {t.path}
            </svg>
            <span>{t.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
